/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedTechnology
 */
export interface PatchedTechnology {
    /**
     * 
     * @type {number}
     * @memberof PatchedTechnology
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedTechnology
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTechnology
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedTechnology
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedTechnology
     */
    logoPath?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedTechnology
     */
    readonly assetsCount?: number;
}

/**
 * Check if a given object implements the PatchedTechnology interface.
 */
export function instanceOfPatchedTechnology(value: object): value is PatchedTechnology {
    return true;
}

export function PatchedTechnologyFromJSON(json: any): PatchedTechnology {
    return PatchedTechnologyFromJSONTyped(json, false);
}

export function PatchedTechnologyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedTechnology {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'version': json['version'] == null ? undefined : json['version'],
        'description': json['description'] == null ? undefined : json['description'],
        'logoPath': json['logo_path'] == null ? undefined : json['logo_path'],
        'assetsCount': json['assets_count'] == null ? undefined : json['assets_count'],
    };
}

  export function PatchedTechnologyToJSON(json: any): PatchedTechnology {
      return PatchedTechnologyToJSONTyped(json, false);
  }

  export function PatchedTechnologyToJSONTyped(value?: Omit<PatchedTechnology, 'id'|'assets_count'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'version': value['version'],
        'description': value['description'],
        'logo_path': value['logoPath'],
    };
}

